import IntegracaoShopeeService from "@/services/IntegracaoShopeeService";

export const integracaoShopee = {
  namespaced: true,
  state: {},
  actions: {
    getConfiguracao() {
      return IntegracaoShopeeService.GetConfiguracao().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    ativar(_, payload) {
      return IntegracaoShopeeService.Ativar(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    autorizar(_, returnUrl) {
      return IntegracaoShopeeService.Autorizar(returnUrl).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    desconectar() {
      return IntegracaoShopeeService.Desconectar().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default integracaoShopee;
